import { Modelo } from '@ext/index';
import * as Types from './Novedad.types';
import moment, { Moment } from 'moment';

export class INovedad extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
    }

    public Id: number = 0;
    public Fecha: Moment;
    public Items: string[] = [];
}
